import React, { useState } from 'react'
import { Button, Input, Label, Modal, Form, FormGroup, ModalBody, FormText, Spinner } from 'reactstrap'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import '../assets/scss/simpl.scss'
import { useSelector } from 'react-redux'
import { makeSelectCodeError } from '../logic/payment'

const validationSchema = Yup.object().shape({
  voucher_code: Yup.string()
      .matches(/^[A-Z0-9]{3}-[A-Z0-9]{5}-[A-Z0-9]{4}$/, 'Der Gutscheincode scheint nicht zu stimmen. Überprüfen Sie bitte die Eingabe.')
      .required('Sie müssen einen Gutscheincode angeben'),
})

const formattedError = {
  'voucher already converted': 'Dieser Gutschein wurden bereits eingelöst',
  'voucher is unpaid': 'Dieser Gutschein wurde noch nicht bezahlt',
}

export default function SimplTicketExchange ({ checkVoucherCode }) {
  const [loading, setLoading] = useState(false)
  const codeError = useSelector(makeSelectCodeError())
  const error = codeError && codeError.body ? codeError.body.error : ''

  if (error && loading) setTimeout(() => setLoading(false), 500)
  // api POST submit
  const onSubmit = async values => {
    setLoading(true)
    try {
      checkVoucherCode(values.voucher_code)
    } catch(e) {
      console.error(e)
    }
  }

  const formik = useFormik({
    initialValues: {
      voucher_code: '',
    },
    validationSchema,
    onSubmit,
  })

  return (
    <div className="row">
      <div className="col">
        <h3 className="exchange-tickets">Gutschein einlösen</h3>
        <Form className="simpl-form" onSubmit={formik.handleSubmit}>
          <FormGroup>
            <Label for="voucher_code">Gutscheincode</Label>
            {formik.errors.voucher_code && formik.touched.voucher_code
              && <FormText color="danger">{formik.errors.voucher_code}</FormText> }
            <Input
              type="text"
              id="voucher_code"
              name="voucher_code"
              disabled={loading}
              onChange={formik.handleChange}
              value={formik.values.voucher_code}
            />
            <FormText>z.B.: B71-ABCDE-2AD3</FormText>
          </FormGroup>
          <Button
            type="submit"
            color="danger"
            disabled={loading}
            block className="mt-4"
          >
            {loading
              ? <Spinner color="light" />
              : <span>Jetzt Einlösen</span>
            }
          </Button>
        </Form>
        { error
          ? <div className="res-error alert alert-warning m-2">{formattedError[error]}</div>
          : null
        }
      </div>
      <div className="col">
        <div className="example-vou" />
      </div>
    </div>
  )
}